import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import { format } from 'date-fns';
import { getBrandName } from 'utils/helpers';
import {
  FORMAT_FULL_DATE_MINI,
  FORMAT_TIME_ONLY,
} from 'utils/helpers/datetime';
import useGoogleRecaptcha from 'components/checkout_form/gift_card/use_google_recaptcha';
import { useLazyTicketByBarcodeQuery } from 'redux/api_slice/issued_tickets';
import { fetchReCapchaToken } from '../../../components/checkout_form/gift_card/helpers';
import TicketManuallyInput from './ticket_manually_input';
import TicketScanner from './ticket_scanner';
import TicketScans from './ticket_scans';

const TicketHistory = () => {
  const [barcode, setBarcode] = useState('');
  const [codeFromUrl, setCodeFromUrl] = useState('');
  const [enterCodeManually, setEnterCodeManually] = useState(false);
  const [getTicketByBarcode, { data, isSuccess, isError, isFetching }] =
    useLazyTicketByBarcodeQuery();
  const history = useHistory();
  const location = useLocation();

  useGoogleRecaptcha();

  useEffect(() => {
    const urlParams = new URLSearchParams(location?.search);
    const code = urlParams.get('code');
    if (code) {
      setCodeFromUrl(code);
      setEnterCodeManually(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // If the code is valid and we’re able to show the scan history to the user,
  // append the code as a query string to the URL
  useEffect(() => {
    if (isSuccess) {
      history.push(`/ticket-history?code=${barcode}`);
    }
  }, [barcode, isSuccess, history]);

  const usageHistory = data?.scanned_at?.map((timeString) => {
    timeString = timeString.substr(0, 19);
    const dateObj = new Date(timeString);
    const time = format(dateObj, FORMAT_TIME_ONLY);
    const date = format(dateObj, FORMAT_FULL_DATE_MINI);
    return { time, date };
  });
  const usesRemaining = data?.uses_remaining;

  const searchBarcode = async (code) => {
    const recaptchaToken = await fetchReCapchaToken();
    setBarcode(code);
    getTicketByBarcode({ barcode: code, recaptchaToken });
  };

  return (
    <div className="ticket-history--scan-container d-grid gap-4">
      {!enterCodeManually && (
        <TicketScanner
          onScanFinished={searchBarcode}
          enterCodeManually={() => setEnterCodeManually(true)}
        />
      )}

      {enterCodeManually && (
        <TicketManuallyInput
          codeFromUrl={codeFromUrl}
          onSubmit={searchBarcode}
          isFetching={isFetching}
          scanWithCamera={() => setEnterCodeManually(false)}
        />
      )}

      {isFetching && (
        <div className="d-flex align-items-center gap-3">
          <i className="fad fa-2x fa-spinner-third animation-momentum-spin text-primary" />
          Checking ticket {barcode}...
        </div>
      )}

      {isError && (
        <div className="alert alert-danger" role="alert">
          <i className="fas fa-times-circle text-danger" />
          <span className="text-x-small">
            {`This ticket is invalid. Are you sure this is for ${getBrandName()}`}{' '}
            {ecom?.craftConfig?.locationName}? <br /> Scanned barcode ID is{' '}
            <span className="fw-bold">{barcode}</span>.
          </span>
        </div>
      )}

      {isSuccess && !isFetching && (
        <TicketScans
          ticketId={barcode}
          usageHistory={usageHistory}
          usesRemaining={usesRemaining}
        />
      )}
    </div>
  );
};

export default TicketHistory;
